import _axios from 'axios'
import store from '@/store'
import getEnv from '@/utils/env'
import router from '../../router'
const CLIENT_API_URL = `${getEnv('VUE_APP_API_BASE_URL')}/api`

export class API{
    constructor(uri) {
        const axios = _axios.create({
            baseURL: uri,
            responseType: 'json',
            timeout: 30000
        })
        //console.log(uri,'uri');
        //自Vuex取Token
        const token = store.getters['auth/getUserToken'];
        //if (! token) console.log('no token','API.index.js')
        //console.log(token,'API.index.js')
        axios.interceptors.request.use(
            config => {
                config.headers.Authorization = `Bearer ${token}`
                return config;
            },
            error =>{
                return Promise.reject(error);
            }  
        )
        axios.interceptors.response.use(
            response => {
                return response;
            },
            err =>{
                console.log(err)
                if (err && err.response) {
                    switch (err.response.status) {
                      case 400:
                      case 401:
                        console.log("Unauthenticated");
                        store.commit('auth/removeUser');
                        store.commit('auth/removeAccessToken');
                        store.commit('auth/removeCurrentFunction');
                        router.replace({path: '/auth/login', query:{ redirect: router.currentRoute.fullPath}});
                        break;
                      case 404:
                        console.log("找不到該頁面");
                        break;
                      case 500:
                        console.log("伺服器出錯");
                        break;
                      case 503:
                        console.log("服務失效");
                        break;
                      default:
                        console.log(`連接錯誤${err.response.status}`);
                    }
                } else {
                    console.log("連接到服務器失敗");
                }
                return Promise.resolve(err.response);
            }
        )
        this.axios = axios
    }
}

export default new API(CLIENT_API_URL).axios